// import "./assets/styles/main.scss";
import "./assets/styles/main.scss";
import { useContext } from "react";
import { AuthContext } from "./contexts/AuthContext";

import Routers from "./routes/Routers";
import { CompanyContext } from "./contexts/CompanyContext";

function App() {
  const { companyLoader } = useContext<any>(CompanyContext);
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  if (companyLoader) {
    return <div>Loading...</div>;
  }

  if (isLoading) {
    return <>{isAuthenticated ? <div>Loading...</div> : <div>Loading...</div>}</>;
  }

  return <Routers />;
}

export default App;
